export enum FEATURES_FLAG_KEYS {
  BPE = 'bpe',
  SHERPASS = 'sherpass',
  BPE_WITH_RORO = 'bpe-with-roro',
  BPE_UKEU_WITH_RORO = 'bpe_ukeu_with_roro',
  GMR_ELO_OPTION_ACTIVATED = 'gmr_elo_option_activated',
  GMR_AUTOMATED_GENERATION = 'gmr_automated_generation',
  ELO_AUTOMATED_GENERATION = 'elo_automated_generation',
  COMMERCIAL_OFFER_ACCESS_MANAGEMENT = 'commercial_offer_access_management',
  CHECK_ELO_ICS2_FALLBACK_ON_ENS_CREATION = 'check_elo_ics2_fallback_on_ens_creation',
}
